var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-nav",
    {
      staticClass: "w-100 provider_menu cabinet_menu mb-3",
      attrs: { vertical: "" },
    },
    [
      _c(
        "cabinet-submenu",
        {
          attrs: {
            path: "/cabinet/fl44",
            title: "44-ФЗ",
            strong: "",
            attention: _vm.attentionForSections([
              "CabinetFl44NoticesList",
              "CabinetFl44ContractsList",
              "CabinetFl44ProposalsList",
              "CabinetFl44PurchaseReports",
            ]),
          },
        },
        [
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
            ? _c(
                "cabinet-submenu-item",
                {
                  attrs: {
                    to: { name: "CabinetFl44NoticesList" },
                    attention: _vm.attentionFor("CabinetFl44NoticesList"),
                  },
                },
                [_vm._v("Извещения")]
              )
            : _vm._e(),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetFl44ContractsList" },
                attention: _vm.attentionFor("CabinetFl44ContractsList"),
              },
            },
            [_vm._v("Контракты")]
          ),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetFl44ProposalsList" },
                attention: _vm.attentionFor("CabinetFl44ProposalsList"),
              },
            },
            [_vm._v(" Предложения ")]
          ),
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
            ? _c(
                "cabinet-submenu-item",
                {
                  attrs: {
                    to: { name: "CabinetFl44PurchaseReports" },
                    attention: _vm.attentionFor("CabinetFl44PurchaseReports"),
                  },
                },
                [_vm._v("Отчеты по закупкам")]
              )
            : _vm._e(),
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
            ? _c(
                "cabinet-submenu-item",
                { attrs: { to: { name: "CabinetFl44BlockRequests" } } },
                [_vm._v("Запросы блокировок")]
              )
            : _vm._e(),
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
            ? _c(
                "cabinet-submenu-item",
                { attrs: { to: { name: "CabinetFl44LimitsList" } } },
                [_vm._v("Лимиты БО")]
              )
            : _vm._e(),
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetFl44RatingHistory" } } },
            [_vm._v("История рейтинга")]
          ),
        ],
        1
      ),
      _c(
        "cabinet-submenu",
        {
          attrs: {
            path: "/cabinet/fl223",
            title: "223-ФЗ",
            strong: "",
            attention: _vm.attentionForSections([
              "CabinetFl223Notices",
              "CabinetFl223Contracts",
              "CabinetFl223ProposalsList",
            ]),
          },
        },
        [
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL223)
            ? _c(
                "cabinet-submenu-item",
                {
                  attrs: {
                    to: { name: "CabinetFl223Notices" },
                    attention: _vm.attentionFor("CabinetFl223Notices"),
                  },
                },
                [_vm._v("Извещения")]
              )
            : _vm._e(),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetFl223Contracts" },
                attention: _vm.attentionFor("CabinetFl223Contracts"),
              },
            },
            [_vm._v("Договоры")]
          ),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetFl223ProposalsList" },
                attention: _vm.attentionFor("CabinetFl223ProposalsList"),
              },
            },
            [_vm._v("Предложения")]
          ),
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL223)
            ? _c(
                "cabinet-submenu-item",
                { attrs: { to: { name: "CabinetFl223Settings" } } },
                [_vm._v("Настройки")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "cabinet-submenu",
        {
          attrs: {
            path: "/cabinet/commercial",
            title: "Коммерческие",
            strong: "",
            attention: _vm.attentionForSections([
              "CabinetCommercialNotices",
              "CabinetCommercialContracts",
              "CabinetCommercialProposalsList",
            ]),
          },
        },
        [
          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_COMMERCIAL)
            ? _c(
                "cabinet-submenu-item",
                {
                  attrs: {
                    to: { name: "CabinetCommercialNotices" },
                    attention: _vm.attentionFor("CabinetCommercialNotices"),
                  },
                },
                [_vm._v(" Извещения ")]
              )
            : _vm._e(),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetCommercialContracts" },
                attention: _vm.attentionFor("CabinetCommercialContracts"),
              },
            },
            [_vm._v("Договоры")]
          ),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: { name: "CabinetCommercialProposalsList" },
                attention: _vm.attentionFor("CabinetCommercialProposalsList"),
              },
            },
            [_vm._v(" Предложения ")]
          ),
        ],
        1
      ),
      _c(
        "cabinet-submenu",
        { attrs: { path: "/cabinet/quotation_requests", title: "Запросы КП" } },
        [
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: {
                  name: "CabinetQuotationRequestsList",
                  params: { cat: "all" },
                },
              },
            },
            [_vm._v("Запросы")]
          ),
          _c(
            "cabinet-submenu-item",
            {
              attrs: {
                to: {
                  name: "CabinetQuotationRequestsOffersList",
                  params: { cat: "all" },
                },
              },
            },
            [_vm._v("Предложения")]
          ),
        ],
        1
      ),
      _c(
        "cabinet-menu-item",
        { attrs: { to: { name: "CabinetAccounting" } } },
        [_vm._v("Лицевой счет")]
      ),
      _c(
        "cabinet-submenu",
        { attrs: { path: "/cabinet/ktru", title: "КТРУ" } },
        [
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetKtruRequestsList" } } },
            [_vm._v("Запросы на добавление позиции")]
          ),
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetKtruFavoritesList" } } },
            [_vm._v("Избранное")]
          ),
        ],
        1
      ),
      _c(
        "cabinet-menu-item",
        { attrs: { to: { name: "CabinetNotificationsList" } } },
        [_vm._v("Уведомления")]
      ),
      _c(
        "cabinet-menu-item",
        { attrs: { to: { name: "CabinetPersonalAddresses" } } },
        [_vm._v("Адресная книга")]
      ),
      _c(
        "cabinet-menu-item",
        { attrs: { to: { name: "CabinetOrganizationReliabilityReport" } } },
        [_vm._v("Проверка контрагентов")]
      ),
      _c(
        "cabinet-submenu",
        {
          attrs: {
            path: ["/cabinet/organization", "/cabinet/user_profile"],
            title: "Об организации",
          },
        },
        [
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetOrganizationProfile" } } },
            [_vm._v("Информация об организации")]
          ),
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetUserProfile" } } },
            [_vm._v("Данные учетной записи")]
          ),
          _c(
            "cabinet-submenu-item",
            { attrs: { to: { name: "CabinetUsersList" } } },
            [_vm._v("Пользователи организации")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }